import { Paperclip, FileText } from "lucide-react";
import type { Task } from "../../mock/types";
import { formatBytes } from "../../mock/helpers";

export function AttachmentsSection({ task }: { task: Task }) {
	return (
		<section>
			<div className="mb-3 flex items-center gap-2">
				<Paperclip className="h-4 w-4 text-muted" />
				<h3 className="text-sm font-semibold text-foreground">
					Attachments
				</h3>
				<span className="text-xs text-muted">
					{task.attachments.length}
				</span>
			</div>
			{task.attachments.length === 0 ? (
				<p className="text-xs text-muted">No attachments.</p>
			) : (
				<ul className="space-y-2">
					{task.attachments.map((a) => (
						<li
							key={a.id}
							className="flex items-center gap-3 rounded-lg border border-border bg-surface px-3 py-2"
						>
							<FileText className="h-4 w-4 text-muted shrink-0" />
							<span className="flex-1 truncate text-sm text-foreground">
								{a.file_name}
							</span>
							<span className="text-xs text-muted">
								{formatBytes(a.file_size)}
							</span>
						</li>
					))}
				</ul>
			)}
		</section>
	);
}
